import React from 'react';
import {Tabs} from 'antd';
import OrderList from './OrderList';
import styles from './OrderManage.less';

//商品类型(与后端 commodityType 对应)
const ORDER_TABS = [
    {
        key: 'position',
        label: '职业订单',
    },
    {
        key: 'company_seat',
        label: '企业成员席位订单',
    },
    {
        key: 'device_service',
        label: '设备服务订单',
    },
    {
        key: 'compute_power',
        label: '算力订单',
    },
    {
        key: 'magicPowerDeposit',
        label: '灵能充值',
    },
];

export default function OrderManageTabs(props) {
    return <Tabs
        className={styles.fullPage}
        items={ORDER_TABS.map((tab) => {
            return {
                key: tab.key,
                label: tab.label,
                children: (
                    <div className={styles.tabPaneBox}>
                        <OrderList
                            {...props}
                            commodityType={tab.key}
                        />
                    </div>
                ),
            };
        })}
    />
}
